import m from 'mithril'

export default {
  view: (vnode) => {
    const thuleImg = require('./thule.jpg')

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-03-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text mod-h3">
            Thulefolket
          </h3>
          <p className="log-book-text">
            Indtil 1953 boede der 27 familier fra Thulefolket nær Thulebasen. De boede i lave tørvehytter og levede af at fange sæler, hvalros, ræve og andre dyr. 
          </p>

          <figure className="log-book-figure">
            <img src={thuleImg} className="log-book-img" />
            <figcaption className="log-book-figcaption">
              Amerikansk soldat foran forladt tørvehytte (foto: Søren Gregersen).
            </figcaption>
          </figure>
        </div>
      </div>
    )
  },
}
